'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import posthog from 'posthog-js';
import { ensurePostHogInitialized, trackClientEvent } from '@/lib/client-analytics';

function isTrackedWorkspacePath(pathname: string) {
  return pathname === '/chat' || pathname.startsWith('/chat/') || pathname.startsWith('/admin');
}

export function PostHogProductActivityTracking() {
  const pathname = usePathname();
  const lastTrackedPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (!ensurePostHogInitialized()) {
      return;
    }

    if (!pathname || !isTrackedWorkspacePath(pathname)) {
      return;
    }

    if (lastTrackedPathRef.current === pathname) {
      return;
    }

    lastTrackedPathRef.current = pathname;
    trackClientEvent('plotsalot_workspace_viewed', {
      page_path: pathname,
      page_category: pathname.startsWith('/admin') ? 'admin' : 'chat',
      replay_enabled: posthog.sessionRecordingStarted(),
      surface: pathname.startsWith('/admin') ? 'admin' : 'chat_workspace',
    });
  }, [pathname]);

  return null;
}
